export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "pl": {
        "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szukaj"])},
        "CALLSIGN": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Znak Stacji"])}
      }
    }
  })
}
